// extracted by mini-css-extract-plugin
export default {"imgdiv":"_8d3d8a5a25 ca787ebbf4","img":"_411409b0e3 _2275debf2a"};